<!-- <div class="create-booking-page"> -->
  <!-- loading -->
  <app-loader *ngIf="isLoading"></app-loader>

  
  <ng-container *ngIf="isLoading === false && formDetails">

    <!-- page header -->
 <!--    <div class="create-booking-header">
      <app-stepper class="stepper" [activeStep]="activeStep" [steps]="stepperDetails" (stepChangeCallback)="onTabClick($event)" [formArray]="stepperReference"></app-stepper>
      <div class="actions">
        <app-button type="plainText" text="Cancel" class="mr-20" (click)="cancelRequestView()"></app-button>
      </div>
    </div> -->

    <!-- steps content -->
 <!--    <div class="create-booking-content">
      <app-user-details
        [bookingEditConfig]="bookingEditConfig"
        [formDetails]="formDetails.get('userDetails')"
        [tripFormDetails]="formDetails.get('tripDetails')"
        *ngIf="activeStep == 0"
      ></app-user-details>
      <app-trip-details
        [bookingEditConfig]="bookingEditConfig"
        [bookingCreationCutoff]="bookingCreationCutoff"
        [formDetails]="formDetails.get('tripDetails')"
        [userDetails]="formDetails.get('userDetails').getRawValue()"
        *ngIf="activeStep == 1"
        (backCallback)="showPreviousStep()"
        (nextCallback)="showNextStep()">
      </app-trip-details>
      <app-confirm-request
        *ngIf="activeStep == 2"
        [formDetails]="formDetails" 
        [workflowConfig]="commonService.workflowConfig"
        (backCallback)="showPreviousStep()"
      ></app-confirm-request>
    </div>
    <div *ngIf="loadingError">Error loading page</div>
  </ng-container> -->
  <div class="stepper-header">
    <mat-stepper #stepper (selectionChange)="selectionChange($event)" [linear]="linear">
      <!--- [completed]="(this.formDetails.get('userDetails').valid && !this.formDetails.get('userDetails').disabled) || this.formDetails.get('userDetails').get('riders').length" -->
      <mat-step label="User Details" [stepControl]="formDetails.get('userDetails')"  errorMessage="">
        <div class="mat-step-content user-details">
          <div class="mat-step-inner-wrapper">
              <app-user-details
                [bookingEditConfig]="bookingEditConfig"
                [formDetails]="formDetails.get('userDetails')"
                [tripFormDetails]="formDetails.get('tripDetails')"
                *ngIf="activeStep == 0 && config && reqRiderDropdown"
                [reqRiderDropdown]="reqRiderDropdown"
                [referenceBooking]="referenceBooking"
                [miscelleneousConfig]="miscellConfig"
                [configComplete]="config"
                (notAllGuestEmitter)="isAllGuest = $event"
                >
              </app-user-details>
        </div>
        </div> 
        <div class="mat-step-action">
          <div class="action-button-group">
            <button mat-raised-button *ngIf="activeStep < 2 && (!miscellConfig['verifyEngagementCode'] || isAllGuest); else engagementBtn" color="primary" [disabled]="!formDetails.get('userDetails').valid" (click)="chooseFunctionCall()">Next</button>
            <ng-template #engagementBtn>
              <button mat-raised-button *ngIf="activeStep < 2" color="primary" [disabled]="!formDetails.get('userDetails').valid" (click)="toggleEngagementPopover()">Add Engagement Code</button>
            </ng-template>
          </div>
        </div>
        <app-popover
        *ngIf="showEngagementPopover"
        titleText="Add Engagement Code"
        size='full'
        (closeCallback)="toggleEngagementPopover()"
        >
          <div popover-content>
            <app-engagement-code-input [ridersFormArray]="formDetails?.get('userDetails')?.get('riders')" [engagementForm]="engagementForm">
            </app-engagement-code-input>
          </div>
          <div popover-actions class="displayFlex engagement_popover_actions">
            <button
            class="verify-btn displayFlex align-item-center" 
            (click)="toggleEngagementPopover()"
            >Cancel
            </button>
            <app-button 
            type="primaryFilled" 
            text="Go to trip details"
            [disabled]="!formDetails.get('userDetails').valid" 
            (clickCallback)="chooseFunctionCall()">
            </app-button>
          </div>
        </app-popover>
      </mat-step>
      <mat-step label="Trip Details" [stepControl]="formDetails.get('tripDetails')" errorMessage="">
        <div class="mat-step-content trip-details">
          <div class="mat-step-inner-wrapper">
              <app-trip-details
              [bookingEditConfig]="bookingEditConfig"
              [bookingCreationCutoff]="bookingCreationCutoff"
              [formDetails]="formDetails.get('tripDetails')"
              [userDetails]="formDetails.get('userDetails').getRawValue()"
              *ngIf="activeStep == 1 && config"
              [referenceBooking]="referenceBooking"
              [miscellConfig]="miscellConfig"
              [workflowConfig]="commonService.workflowConfig"
              [configComplete]="config"
              [designationConfig]="designationConfig"
              [isAllGuest]="isAllGuest"
              [engagementForm]="engagementForm"
              >
            </app-trip-details>
        </div>
        </div>
        <div class="mat-step-action">
          <div class="action-button-group">
            <button class="footer-back-btn" mat-stroked-button *ngIf="activeStep > 0" color="primary" (click)="showPreviousStep()" matStepperPrevious>Back</button>
            <button mat-raised-button *ngIf="activeStep < 2" class="ml-16" color="primary" [disabled]="!formDetails.get('tripDetails').valid" (click)="chooseFunctionCall()">Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step label="Confirm Details" >
        <div class="mat-step-content confirm-details">
          <div class="mat-step-inner-wrapper">
              <app-confirm-request
              *ngIf="activeStep == 2 && config"
              [formDetails]="formDetails" 
              [workflowConfig]="commonService.workflowConfig"
              [customManagerPopups]="customManagerPopup"
              (needMangerApproval)="needMangerApproval($event)"
              (submitBookingWithManager)="submitBookingWithManager($event)"
              (closeDialogbox)="closeDialog($event)"
              [miscellConfig]="miscellConfig"
              [config]="config"
              [escortConfig]="escortConfig"
              >
              </app-confirm-request>
        </div>
        </div>
        <div class="mat-step-action">
          <div class="action-button-group">
            <button class="footer-back-btn" mat-stroked-button *ngIf="activeStep > 0" color="primary" (click)="showPreviousStep()" matStepperPrevious>Back</button>
             <button mat-raised-button *ngIf="activeStep == 2" class="ml-16" color="primary" (click)="submitNewBooking()">Submit</button>
          </div>
        </div>
      </mat-step>
     <!--  <mat-step state="chat" class="cancel-button-stepper">
        <ng-template matStepLabel>
          <button mat-stroked-button class="cancel-booking" color="primary" (click)="cancelRequestView()">Cancel Booking</button>
        </ng-template>
      </mat-step>
      <ng-template matStepperIcon="chat">
      </ng-template> -->
    </mat-stepper>
    <div *ngIf="miscellConfig['enableBookingInstructions']" (click)="openDrawer()" class="instructions font-weight-700 fs-15 displayFlex align-item-center"> <span class="mr-4 mt-2"> <img src="assets/instruction.svg" alt=""></span> Booking Instructions</div>
    <button mat-stroked-button class="cancel-booking" color="primary" (click)="cancelRequestView()">Cancel Booking</button>
  </div>
  <app-dialog *ngIf="showConfirmBookingPopup" titleText="Confirm Booking" type="confirm" [buttonText]="['Yes', 'No']"
  (approveCallback)="onSubmit()" (dismissCallback)="exitCreateBooking()"
  (closeCallback)="showConfirmBookingPopup=false"  [src]="'assets/images/cancel_24.svg'"
  [icon]="false">
  <div *ngIf=" guardReq && (authService.user.role=='TRANSPORT_MANAGER' || authService.user.role.toLowerCase()=='EMPLOYEE'.toLowerCase())">
    <div class="fs-16 font-weight-700">
      Marshall assigned trips will start {{preponeTripSheetInHours}} hours prior to the selected pick-up time. 
    </div>
    <br>
  </div>
  Are you sure you want to proceed further with this booking?
  </app-dialog>
</ng-container>
  <!-- page footer -->
  <!-- <div class="create-booking-footer">
    <app-button *ngIf="activeStep > 0" class="mr-10" type="plainText" text="Back" (clickCallback)="showPreviousStep()"></app-button>
    <app-button *ngIf="activeStep < 2" type="primaryFilled" text="Next" (clickCallback)="chooseFunctionCall()"></app-button>
    <app-button *ngIf="activeStep == 2" type="primaryFilled" text="Submit" (clickCallback)="onSubmit()"></app-button>
  </div>
 -->
  <!-- popup messages -->
  <app-dialog *ngIf="isNoRiderErrorVisible" titleText="Error"  type="alert" [buttonText]="['Okay']" (approveCallback)="toggleNoRiderError()">
    You must add at least one rider to continue.
  </app-dialog>
  <app-popover *ngIf="showErrorMsg" size="medium" titleText="Message" (closeCallback)="dismissPopup()">

    <div popover-content>
      <div class="mb-10" *ngIf="showAddButton">
        Card details are not added for payer of this booking. 
        Your card details are not available.
        You cannot proceed with booking creation as you are the payer for this booking.
        Please add your card details from My Profile page available on the left menu.
      </div>
      <div class="mb-10" *ngIf="!showAddButton">
        Card details are not added for payer of this booking. 
        You cannot proceed with booking creation. 
        Please check with payer for adding card details. 
        Card details can be added from My Profile page available on the left menu.
      </div>
    </div>
    <div popover-actions class="mt-20 flex flex-end">
      <app-button class="mr-10" type="plainButton" *ngIf="showDiffPayerButton" text="Choose Different Payer" (clickCallback)="dismissPopup()">
      </app-button>
      <app-button type="plainButton" text="Cancel Booking" (clickCallback)="cancelRequestView()">
      </app-button>
      <app-button type="plainButton" text="Add Card" *ngIf="showAddButton" (clickCallback)="navigateToProfile()">
      </app-button>
    </div>

  </app-popover>
  <app-dialog
    *ngIf="bookingCutoffMessage"
    titleText="Booking cannot be created"
    type="alert"
    [buttonText]="['Okay']"
    (approveCallback)="closeBookingCutoff()"
  >
    {{bookingCutoffMessage}}
  </app-dialog>

  <app-dialog
    *ngIf="isBookingCreationError"
    [titleText]="isEditMode ? 'Booking cannot be updated' : 'Booking cannot be created'"
    type="alert"
    [buttonText]="['Okay']"
    (approveCallback)="showBookingFail()"
  >
    {{bookingCreationErrorMsg}}
  </app-dialog>

  <app-dialog *ngIf="isExitPopupVisible" titleText="Confirm"  type="confirm" [buttonText]="['Yes', 'No']" (approveCallback)="exitView()" (dismissCallback)="toggleExitPopup()">
    Any changes you have made will be lost. Are you sure you want to leave?
  </app-dialog>
<!-- </div> -->

